/**
 * Scroll affordance for web lists (14.6).
 *
 * Almost every list in the app passes `showsVerticalScrollIndicator={false}`,
 * which is the right call on a touch device: the content is dragged directly
 * and a permanent scrollbar is just clutter. On a desktop browser it removes
 * the only cue that a region scrolls at all, and the only thing a mouse user
 * can grab - react-native-web implements the prop as `scrollbar-width: none`,
 * so the scrollbar is genuinely gone, not merely faded.
 *
 * Spreading this after a screen's own props flips that one prop back on for
 * web without touching the native behaviour, and without each screen having to
 * write its own Platform check.
 */

export const webScrollbarProps = {showsVerticalScrollIndicator: true};

/**
 * The opposite case (16.11 - 16.13): a scroll area that must scroll but must
 * not show a bar.
 *
 * `showsVerticalScrollIndicator={false}` is the react-native way to ask for
 * this, and react-native-web implements it as `scrollbar-width: none`. That is
 * the standard property and current Chrome and Edge honour it, but older
 * Chromium only understands `::-webkit-scrollbar` - and this app's own
 * stylesheet gives that pseudo-element a 10px width, which puts the bar back.
 *
 * The marker below lets globalStyles.web.ts answer both, so the bar is hidden
 * on every supported browser while overflow scrolling - wheel, trackpad,
 * keyboard - keeps working untouched. Scrolling is never disabled; only the
 * bar is, and at zero width it takes no layout space either.
 */
export const webHiddenScrollbarProps = {
  dataSet: {zenHideScrollbar: 'true'},
};
